/**
 * ACL Action constants for Projects module
 * These correspond to the action names defined in the database and enforced by the API
 */

// Project-specific actions
export const PROJECT_ACTIONS = {
  LIST_PROJECTS: 'list-projects',
  GET_PROJECT: 'get-project',
  CREATE_PROJECT: 'create-project',
  UPDATE_PROJECT: 'update-project',
  ARCHIVE_PROJECT: 'archive-project',
  DOWNLOAD_PROJECT: 'download-project',
  COPY_PROJECT_LINK: 'copy-project-link',
  PRINT_PROJECT: 'print-project',
} as const;

// System-level admin action that bypasses all ACL checks
export const ADMIN_SITEWIDE_ACCESS = 'admin-sitewide-access';

// Zero GUID used for "All" scope selections
export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

// Type for project action values
export type ProjectAction = typeof PROJECT_ACTIONS[keyof typeof PROJECT_ACTIONS];
